require("./global.css");

const { canonicalHrefForPath } = require("./src/utils/canonicalBase");

export { default as wrapRootElement } from "./src/redux/ReduxWrapper";

/** After navigation, keep canonical on pathname only (drops ?hash=… from the link tag). */
export const onRouteUpdate = ({ location }) => {
  if (typeof document === "undefined" || !location?.pathname) return;
  const link = document.querySelector('link[rel="canonical"]');
  if (link) {
    link.setAttribute("href", canonicalHrefForPath(location.pathname));
  }
};
